import { Epic } from 'redux-observable';
import { switchMap, withLatestFrom, filter } from 'rxjs/operators';
import { settingsViewOnChangeActiveTab } from '../settingsViewSlice';
import { RootState } from '../../../../store';
import { routingOnRouteRequest } from 'src/app/store/routingSlice';
import { settingTabToRouteMap } from 'src/routes';
import { PayloadAction } from '@reduxjs/toolkit';
import { getRouterLocation } from 'src/api/store/routingSlice/utils';

type IN = ReturnType<typeof settingsViewOnChangeActiveTab>;
type OUT = ReturnType<typeof routingOnRouteRequest>;

export const SettingsViewOnChangeActiveTab: Epic<IN | OUT, OUT, RootState> = (
  action$,
  state$,
) =>
  action$.pipe(
    filter(settingsViewOnChangeActiveTab.match),
    withLatestFrom(state$),
    switchMap(([{ payload: nextActiveTab }, state]) => {
      const nextActions: PayloadAction<any, any>[] = [];
      const { path: currRoute } = getRouterLocation();
      const nextRoute = settingTabToRouteMap[nextActiveTab];

      if (currRoute !== nextRoute) {
        nextActions.push(routingOnRouteRequest({ path: nextRoute }));
      }

      return nextActions;
    }),
  );
